import type React from "react"
import { useTranslation } from "react-i18next"

import type { Option } from "@/nzds/inputs/inputs.types"
import { TextField } from "@/nzds/inputs/text-field"

import { MenuItem } from "@mui/material"

interface ResourceFieldProps {
  disabled?: boolean
  onChange: (value: string) => void
  options: readonly Option[]
  value: string
}

const optionValue = (option: Option): string | null =>
  typeof option.value === "string" ? option.value : null

export const ResourceField: React.FC<ResourceFieldProps> = ({
  disabled = false,
  onChange,
  options,
  value,
}) => {
  const { t } = useTranslation("common")

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const next = event.target.value
    const listed = options.some((option) => optionValue(option) === next)
    if (!listed) {
      return
    }
    onChange(next)
  }

  return (
    <TextField
      disabled={disabled}
      label={t("fields.resource.title")}
      onChange={handleChange}
      select
      sx={{ minWidth: 180 }}
      value={value}
    >
      {value === "" ? <MenuItem value="" /> : null}
      {options.map((option) => {
        const next = optionValue(option)
        if (next == null) {
          return null
        }

        return (
          <MenuItem key={next} value={next}>
            {option.label}
          </MenuItem>
        )
      })}
    </TextField>
  )
}
